import React from "react";

import ApplicationForm from "@/components/forms/ApplicationForm";
import SideNavLayout from "@/layouts/SideNavLayout";

const NewScreeningPage = () => {
  return (
    <SideNavLayout>
      <div className="my-3">
        <ApplicationForm />
      </div>
    </SideNavLayout>
  );
};

NewScreeningPage.propTypes = {};

export default NewScreeningPage;
